// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class GoogleMapDetail extends WebComponent {
    constructor(props) {
        super(props);
        this.initMap = this.initMap.bind(this);
    }

    didMount() {
        const {
            lat,
            lng
        } = this.props;

        const mapElement = this.element;
        this.initMap(mapElement,parseFloat(lat),parseFloat(lng));
    }

    initMap(mapElement, coordLat, coordLng) {
        const location = {lat: coordLat, lng: coordLng};
        // The map, centered
        const map = new google.maps.Map(
            mapElement, {
                zoom: 13,
                center: location,
                minZoom: 3,
                mapTypeControl:    false,
                scaleControl:      false,
                panControl:        true,
                streetViewControl: false,
                zoomControl:       true,
                scrollwheel:       false
            });
        // The marker, positioned
        const marker = new google.maps.Marker({position: location, map: map});
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMapDetail.js